import { Command } from 'commander'
import { preview } from './preview'
import { verify } from './verify'

export const docs = new Command()
	.name('docs')

	.description('Hashnode docs commands')

docs.addCommand(preview)

docs.addCommand(verify)
